import { ReactNode } from "react"

import { AuthProvider } from "./useAuth"

const AppProvider = ({ children }: { children: ReactNode }) => (
  <AuthProvider>{children}</AuthProvider>
)

export default AppProvider
